const urlCleanRegex = /[\W_]+/g;

/**
 * Builds the SEO slug path segments for an activity-location (POI) detail
 * route (`/<category>/:location/:name/:id`), matching the shape
 * `serverless/sitemap/sitemap-generator.js` already generates for POIs.
 * `location`/`name` are omitted when the source data is missing, which is
 * why the router registers `:location/:name/:id`, `:name/:id`, and bare
 * `:id` as sibling routes — same pattern as `buildListingSlugSegments`.
 */
export function buildActivityLocationSlugSegments(
  prefix: string,
  entry: { id?: number; name?: string; address?: { city?: string; state?: string } },
): string[] {
  const segments: string[] = ['', prefix];
  const city = entry.address?.city;
  const state = entry.address?.state;
  if (city?.trim() && state?.trim()) {
    segments.push(
      encodeURIComponent(`${city.replace(urlCleanRegex, '-')}_${state.replace(urlCleanRegex, '-')}`).toLowerCase(),
    );
  }
  if (entry.name) {
    segments.push(encodeURIComponent(entry.name.replace(urlCleanRegex, '-')).toLowerCase());
  }
  if (entry.id) {
    segments.push(entry.id.toString());
  }
  return segments;
}
